import { createContext, useContext } from "react";

export const TagsContext = createContext<string[]>([]);

export function useTagsContext() {
    return useContext(TagsContext);
}
